// 该配置主要用于页面内按钮权限判断，key为按钮，值对应权限资源管理的资源code
export const permissionCodes: any = {
  // 资源管理
  resourceSearchBtn: 'per:res:q', // 查询按钮
  resourceAddBtn: 'per:res:c', // 添加按钮
  resourceEditBtn: 'per:res:u', // 编辑按钮
  resourceDeleteBtn: 'per:res:d', // 删除按钮
  resourceUpdateStatusBtn: 'per:res:status:u', // 修改状态按钮
  // 业务管理
  businessSearchBtn: 'per:scope:q', // 查询按钮
  businessAddBtn: 'per:scope:c', // 添加按钮
  businessEditBtn: 'per:scope:u', // 编辑按钮
  businessDeleteBtn: 'per:scope:d', // 删除按钮
  businessUpdateStatusBtn: 'per:scope:status:u', // 修改状态按钮
  // 应用管理
  appSearchBtn: 'per:app:q', // 查询按钮
  appAddBtn: 'per:app:c', // 添加按钮
  appEditBtn: 'per:app:u', // 编辑按钮
  appDeleteBtn: 'per:app:d', // 删除按钮
  appUpdateStatusBtn: 'per:app:status:u', // 修改状态按钮
  // 小程序管理
  mAppSearchBtn: 'per:mapp:q', // 查询按钮
  mAppAddBtn: 'per:mapp:c', // 添加按钮
  mAppEditBtn: 'per:mapp:u', // 编辑按钮
  mAppDeleteBtn: 'per:mapp:d', // 删除按钮
  mAppUpdateStatusBtn: 'per:mapp:status:u', // 修改状态按钮
  mAppQrcodeBtn: 'per:mapp:qrcode:q', // 修改状态按钮

  // 菜单管理
  menuSearchBtn: 'per:menu:q', // 查询按钮
  menuAddBtn: 'per:menu:c', // 添加按钮
  menuEditBtn: 'per:menu:u', // 编辑按钮
  menuDeleteBtn: 'per:menu:d', // 删除按钮
  menuUpdateStatusBtn: 'per:menu:status:u', // 修改状态按钮
  // 模块管理
  modSearchBtn: 'per:mod:q', // 查询按钮
  modAddBtn: 'per:mod:c', // 添加按钮
  modEditBtn: 'per:mod:u', // 编辑按钮
  modDeleteBtn: 'per:mod:d', // 删除按钮
  modUpdateStatusBtn: 'per:mod:status:u', // 修改状态按钮
  // 用户管理
  userSearchBtn: 'per:user:q', // 查询按钮
  userSeeLogin: 'per:user:login:q', // 查询按钮
  // 日志管理
  logSearchBtn: 'per:log:login:q', // 查询按钮
  // 标签管理
  sysSearchBtn: 'sys:tag:q', // 查询按钮
  sysAddBtn: 'sys:tag:c', // 添加按钮
  sysEditBtn: 'sys:tag:u', // 编辑按钮
  sysDeleteBtn: 'sys:tag:d', // 删除按钮
  // 租户管理
  csrSearchBtn: 'csr:tenant:q', // 查询按钮
  csrAddBtn: 'csr:tenant:c', // 增加租户
  csrEditBtn: 'csr:tenant:u', // 基本信息
  csrDeleteBtn: 'csr:tenant:d', // 删除按钮
  csrModDeleteBtn: 'csr:tenant:mod:config', // 模块信息按钮
  csrUpdateStatusBtn: 'csr:tenant:status:u', // 修改状态
  // 组织管理
  orgSearchBtn: 'csr:org:q', // 查询按钮
  orgAddBtn: 'csr:org:c', // 增加组织
  orgEditBtn: 'csr:org:u', // 编辑
  orgDeleteBtn: 'csr:org:d', // 删除按钮
  orgLabelBtn: 'csr:org:label', // 编辑标签
  orgStatusBtn: 'csr:org:status:u', // 编辑标签
  // 部门管理
  deptSearchBtn: 'csr:dept:q', // 查询按钮
  deptAddBtn: 'csr:dept:c', // 添加部门
  deptEditBtn: 'csr:dept:u', // 编辑
  deptDeleteBtn: 'csr:dept:d', // 删除按钮
  deptStatusBtn: 'csr:dept:status:u', // 修改状态按钮
  // 角色管理
  roleSearchBtn: 'csr:role:q', // 查询按钮
  roleAddBtn: 'csr:role:c', // 添加部门
  roleEditBtn: 'csr:role:u', // 编辑
  roleDeleteBtn: 'csr:role:d', // 删除按钮
  roleStatusBtn: 'csr:role:status:u', // 修改状态按钮
  roleDataBtn: 'csr:role:data:config', // 数据权限
  roleResBtn: 'csr:role:res:config', // 资源权限
  roleEmpBtn: 'csr:role:emp:q', // 查看员工

  // 员工管理
  empSearchBtn: 'csr:emp:q', // 查询按钮
  empAddBtn: 'csr:emp:c', // 增加员工
  empEditBtn: 'csr:emp:u', // 编辑基本信息
  empDeleteBtn: 'csr:emp:d', // 删除按钮
  empStatusBtn: 'csr:emp:status:u', // 修改状态按钮
  empDataBtn: 'csr:emp:role:config', // 角色
  empResPswBtn: 'csr:emp:role:psw', // 重置密码

  // 通知渠道管理
  notAddBtn: 'csr:cha:nc', // 添加通知渠道
  notEditBtn: 'csr:cha:ec', // 编辑通知渠道
  notDeleteBtn: 'csr:cha:dc', // 删除通知渠道

  chaSearchBtn: 'csr:cha:q', // 查询按钮
  chaAddBtn: 'csr:cha:c', // 增加
  chaEdiBtn: 'csr:cha:u', // 编辑渠道配置
  chaDeleteBtn: 'csr:cha:d', // 删除按钮
  chaStatusBtn: 'csr:cha:status:u', // 修改状态按钮

  // 通知类型管理
  claSearchBtn: 'csr:cla:q', // 查询按钮
  claEditBtn: 'csr:cla:u', // 编辑
  claAddBtn: 'csr:cla:c', // 增加
  claDeleteBtn: 'csr:cla:d', // 删除按钮
  claStatusBtn: 'csr:cla:status:u', // 修改状态按钮

  // 通知模板管理
  tmpSearchBtn: 'csr:tmp:q', // 查询按钮
  tmpEditBtn: 'csr:tmp:u', // 编辑
  tmpAddBtn: 'csr:tmp:c', // 增加
  tmpDeleteBtn: 'csr:tmp:d', // 删除按钮
  tmpStatusBtn: 'csr:tmp:status:u', // 修改状态按钮

  // 支付业务管理
  payBusSearch: 'pay:bus:q', // 查询按钮
  payBusEditBtn: 'pay:bus:u', // 编辑
  payBusAddBtn: 'pay:bus:c', // 增加
  payBusDeleteBtn: 'pay:bus:d', // 删除按钮

  // 支付渠道管理
  payChaSearch: 'pay:cha:q', // 查询按钮
  payChaEditBtn: 'pay:cha:u', // 编辑
  payChaAddBtn: 'pay:cha:c', // 增加
  payChaDeleteBtn: 'pay:cha:d', // 删除按钮

  // 通知停用管理
  noticeDeactivateAddBtn: 'notice:dea:c', // 增加
  noticeDeactivateEditBtn: 'notice:dea:u', // 编辑
  noticeDeactivateDeleteBtn: 'notice:dea:d', // 删除按钮

  // 应用消息管理
  noticeAppMsgAddBtn: 'notice:appMsg:c', // 增加
  noticeAppMsgEditBtn: 'notice:appMsg:u', // 编辑
  noticeAppMsgDeleteBtn: 'notice:appMsg:d', // 删除按钮

  // 黑白名单管理
  noticeSystemAddBtn: 'notice:system:c', // 增加
  noticeSystemEditBtn: 'notice:system:u', // 编辑
  noticeSystemDeleteBtn: 'notice:system:d', // 删除按钮

  // 业务管理
  noticeBusSearch: 'notice:busMsg:q', // 查询按钮
  noticeBusAddBtn: 'notice:busMsg:c', // 增加
  noticeBusEditBtn: 'notice:busMsg:u', // 编辑
  noticeBusDeleteBtn: 'notice:busMsg:d', // 删除按钮
  noticeBusInitBtn: 'notice:busInitMsg:c', // 初始化按钮
  // 中康数据中台
  midDrugTable: 'mid:table:drug', // CFDA 药品表
  midDrugBusTable: 'mid:table:busDrug', // 药品业务信息表
  midDrugComTable: 'mid:table:comDrug', // 药品通用名信息表
  midDrugBarcTable: 'mid:table:barcDrug', // 药品条形码
  // 国家医保局
  medPcTable: 'med:table:pc', // 医保药品数据库 (西药+中成药)
  medCmTable: 'med:table:cm', // 医保药品数据库（中药饮片）
  medIcd9Tree: 'med:tree:icd9', // 西医手术ICD-9-CM3医保2.0版
  medIcd10Tree: 'med:tree:icd10', // 西医疾病ICD-10医保2.0版
  medTcmDiseases: 'med:tree:diseases', // 中医疾病医保2.0版
  medTcmSyndrome: 'med:tree:syndrome', // 中医症候医保2.0版
  medConsumTable: 'med:tree:consumable', // 医保医药耗材数据库
  medServiceTable: 'med:tree:service', // 全国医疗服务项目
  // 互联网医院监管平台
  intDisCodeTable: 'int:table:disCode', // 疾病分类与代码（2019）
  intCataMedTable: 'int:table:cataMed', // 医疗服务收费项目医保目录
  intAdmCodeTable: 'int:table:admCode', // 2018年行政区化码
  intDrugCataTable: 'int:table:drugCata', // 国家药品供应保障综合管理信息平台药品目录
};

export default permissionCodes;
